import OrdersPausedManuallyBanner from './OrdersPausedManuallyBanner';

export default {
  OrdersPausedManuallyBanner,
};
